import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/analytics';

/**
 * Captures $pageview on every route change.
 * Place once inside a component that lives within BrowserRouter.
 */
export function usePageView(): void {
  const location = useLocation();

  useEffect(() => {
    trackEvent('$pageview', {
      $current_url: window.location.href,
      path: location.pathname,
    });
  }, [location.pathname]);
}
